import { render, staticRenderFns } from "./EditFirm.vue?vue&type=template&id=34d64b02"
import script from "./EditFirm.vue?vue&type=script&lang=js"
export * from "./EditFirm.vue?vue&type=script&lang=js"
import style0 from "./EditFirm.vue?vue&type=style&index=0&id=34d64b02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports